<template>
	<div class="tpl my-visitor-wrap">
		<mt-header title="访客记录" fixed>
			<router-link :to="{name:'mine'}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
			<mt-button class="header-right-btn" slot="right"><img src="../../assets/img/common/ic_text_search@2x.png"/></mt-button>
		</mt-header>
		<div class="visitor-header">
			<mt-navbar v-model="selected">
				<mt-tab-item id="1">谁看过我<span class="active-dot"></span></mt-tab-item>
				<mt-tab-item id="2">我看过谁<span class="active-dot"></span></mt-tab-item>
			</mt-navbar>
		</div>
		<mt-tab-container v-model="selected">
			<mt-tab-container-item id="1">
				<div class="visite-me-num">
					<ul>
						<li>
							<p class="item-num">{{visitMeList.sum}}</p>
							<p class="item-name">总浏览量</p>
						</li>
						<li>
							<p class="item-num">{{visitMeList.today?visitMeList.today.length:0}}</p>
							<p class="item-name">今日访客</p>
						</li>
						<li>
							<p class="item-num">{{myVisitList.today?myVisitList.today.length:0}}</p>
							<p class="item-name">今日浏览量</p>
						</li>
					</ul>
				</div>
				<div class="list-title">
					<span>今天</span>
				</div>
				<ul class="visitor-list">
					<li v-for="item in visitMeList.today">
						<div class="item-img">
							<img :src="item.avatar" alt="" />
						</div>
						<div class="item-text">
							<p class="item-name">
								{{item.nickname}}
								<img v-if="item.gender==1" src="../../assets/img/common/ic_user_man@2x.png"/>
								<img v-if="item.gender==2" src="../../assets/img/common/ic_user_woman@2x.png"/>
								<img v-if="item.is_vip" src="../../assets/img/common/ic_user_vip@2x.png"/>
							</p>
							<p class="item-other">
								ID:{{item.uid}}
							</p>
						</div>
						<span class="item-option" @click="showVisitMeOption(item.v_id)"><img src="../../assets/img/trends/dyn_dyn_ic_more.png" alt="" /></span>
					</li>
					<div class="no-content" v-if="!visitMeList.today||visitMeList.today.length<1">
						<!--<img src="../../assets/img/default/bg_img_empty@2x.png" alt="" />-->
						<p>你今天没有看过别人哦~</p>
					</div>
				</ul>
				<div class="list-title">
					<span>过往</span>
				</div>
				<ul class="visitor-list">
					<li v-for="item in visitMeList.earlier">
						<div class="item-img">
							<img :src="item.avatar" alt="" />
						</div>
						<div class="item-text">
							<p class="item-name">
								{{item.nickname}}
								<img v-if="item.gender==1" src="../../assets/img/common/ic_user_man@2x.png"/>
								<img v-if="item.gender==2" src="../../assets/img/common/ic_user_woman@2x.png"/>
								<img v-if="item.is_vip" src="../../assets/img/common/ic_user_vip@2x.png"/>
							</p>
							<p class="item-other">
								ID:{{item.uid}}
							</p>
						</div>
						<span class="item-option" @click="showVisitMeOption(item.v_id)"><img src="../../assets/img/trends/dyn_dyn_ic_more.png" alt="" /></span>
					</li>
					<div class="no-content" v-if="!visitMeList.earlier||visitMeList.earlier.length<1">
						<!--<img src="../../assets/img/default/bg_img_empty@2x.png" alt="" />-->
						<p>你一直没有看过别人吗？？</p>
					</div>
				</ul>
			</mt-tab-container-item>
			<mt-tab-container-item id="2">
				<div class="list-title">
					<span>今天</span>
				</div>
				<ul class="visitor-list">
					<li v-for="item in myVisitList.today">
						<div class="item-img">
							<img :src="item.avatar" alt="" />
						</div>
						<div class="item-text">
							<p class="item-name">
								{{item.nickname}}
								<img v-if="item.gender==1" src="../../assets/img/common/ic_user_man@2x.png"/>
								<img v-if="item.gender==2" src="../../assets/img/common/ic_user_woman@2x.png"/>
								<img v-if="item.is_vip" src="../../assets/img/common/ic_user_vip@2x.png"/>
							</p>
							<p class="item-other">
								ID:{{item.uid}}
							</p>
						</div>
						<span class="item-option" @click="showMyVisitOption(item.is_vip,item.v_id)"><img src="../../assets/img/trends/dyn_dyn_ic_more.png" alt="" /></span>
					</li>
					<div class="no-content" v-if="!myVisitList.today||myVisitList.today.length<1">
						<!--<img src="../../assets/img/default/bg_img_empty@2x.png" alt="" />-->
						<p>今天没有喜欢的人哦~</p>
					</div>
				</ul>
				<div class="list-title">
					<span>过往</span>
				</div>
				<ul class="visitor-list">
					<li v-for="item in myVisitList.earlier">
						<div class="item-img">
							<img :src="item.avatar" alt="" />
						</div>
						<div class="item-text">
							<p class="item-name">
								{{item.nickname}}
								<img v-if="item.gender==1" src="../../assets/img/common/ic_user_man@2x.png"/>
								<img v-if="item.gender==2" src="../../assets/img/common/ic_user_woman@2x.png"/>
								<img v-if="item.is_vip" src="../../assets/img/common/ic_user_vip@2x.png"/>
							</p>
							<p class="item-other">
								ID:{{item.uid}}
							</p>
						</div>
						<span class="item-option" @click="showMyVisitOption(item.is_vip,item.v_id)"><img src="../../assets/img/trends/dyn_dyn_ic_more.png" alt="" /></span>	
					</li>
					<div class="no-content" v-if="!myVisitList.earlier||myVisitList.earlier.length<1">
						<!--<img src="../../assets/img/default/bg_img_empty@2x.png" alt="" />-->
						<p>你一直没有喜欢的人吗？？</p>
					</div>
				</ul>
			</mt-tab-container-item>
			
		</mt-tab-container>
		<mt-actionsheet
		  :actions="visitMeOptions"
		  v-model="visitMeOptionShow">
		</mt-actionsheet>
		<mt-actionsheet
		  :actions="myVisitOptions"
		  v-model="myVisitOptionShow">
		</mt-actionsheet>
	</div>
</template>

<script>
	
	export default{
		name:"my-visitor",
		data(){
			return{
				uid:"",
				isVip:"",
				selected:"1",
				visitMeList:"",		//看过我的
				myVisitList:"",		//我看过的
				visitMePage:1,
				myVisitPage:1,
				visitMeOptionShow:false,
				visitMeOptions:[
					{name:"好友来访通知(会员特权)",method:this.visiteNotice},
					{name:"删除此条访问记录",method:this.deleteVisit},
				],
				myVisitOptionShow:false,
				myVisitOptions:[
					{name:"删除此条访问记录(会员特权)",method:this.deleteVisit},
				],
				vid:"",
				deleteType:1,
			}
		},
		created(){
			this.uid = this.$store.state.UserId;	//获取当前用户的id
			this.$store.commit("changeTabChoosed", "mine");
			this.$store.commit("changeTabBarShow", false);
			
			this.getNomalList(1);
			this.getNomalList(2);
			
			this.isVip = this.$store.state.AdminInfo.isvip;
			console.log(this.$store.state.AdminInfo.isvip);
		},
		methods:{
			getNomalList(type){
				this.$axios({
					url:"My/VisitorsRecordSeenMe",
					method:"post",
					data:{
						uid:this.uid,
						type:type
					}
				}).then(res=>{
					console.log(res.data.data);
					if(res.data.code==200){
						if(type==1){
							this.visitMeList=res.data.data;
						}else if(type==2){
							this.myVisitList=res.data.data;
						}
						
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			showVisitMeOption(id){
				this.visitMeOptionShow=true;
				this.vid = id;
				this.deleteType = 1;
			},
			showMyVisitOption(id){
				this.myVisitOptionShow=true;
				this.vid = id;
				this.deleteType = 2;
			},
			visiteNotice(){
				console.log("通知")
			},
			deleteVisit(){
				if(this.isVip){
					this.$axios({
						url:"My/DelVisitorsRecord",
						method:"post",
						data:{
							uid:this.uid,
							v_id:this.vid,
							type:this.deleteType
						}
					}).then(res=>{
						console.log(res);
						if(res.data.code==200){
							this.$toast({
								message:res.data.msg,
								position:"bottom",
								duration:3000
							})
							this.getNomalList(this.deleteType);
						}
					}).catch(err=>{
						console.log(err)
					})
				}else{
					this.$toast({
						message:"你还不是会员哦~",
						position:"bottom",
						duration:3000
					})
				}
				
			}
		}
	}
</script>

<style scoped>
	.my-visitor-wrap{
		padding-top: 5.5rem;
	}
	.header-right-btn img{
		width: 1.5rem;
	}
	.visitor-header{
		border-bottom: 1px solid #f3f3f3;
		position: fixed;
		width: 100%;
		top: 2.5rem;
		left: 0;
		z-index: 10;
		background: #fff;
	}
	.mint-navbar {
	    width: 50%;
    	padding: 0 0.5rem;
	}
	>>>.mint-navbar .mint-tab-item {
		box-sizing: border-box;
		position: relative;
	}
	.active-dot{
	    display: none;
	    width: 5px;
	    height: 5px;
	    background: #6D34FB;
	    border-radius: 50%;
	    position: absolute;
	    left: 50%;
	    bottom: 0.4rem;
	}
	>>>.mint-tab-item.is-selected .mint-tab-item-label {
		font-size: 1rem;
		font-weight: bold;
		color: #282828;
	}
	>>>.mint-tab-item.is-selected .active-dot{
		display: block;
	}
	>>>.mint-navbar .mint-tab-item.is-selected {
		border-bottom: 0;
	}
	.list-title{
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: #fff;
		padding: 0.5rem 1rem;
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
	}
	.list-title .num{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 0.8rem;
		color: #5415F9;
		font-weight: normal;
	}
	.list-title .num img{
		width: 1.5rem;
	}
	
	.visite-me-num ul{
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: #fff;
		border-bottom: 1px solid #f3f3f3;
	}
	.visite-me-num ul li{
		flex: 1;
		text-align: center;
		padding: 0.8rem 0;
	}
	.visite-me-num ul li p.item-num{
		font-size: 1.2rem;
		line-height: 1.8rem;
		color: #5415F9;
		font-weight: bold;
		margin-bottom: 0.5rem;
	}
	.visite-me-num ul li p.item-name{
		font-size: 0.9rem;
		color: #7b7b7b;
	}
	
	.visitor-list{
		margin-bottom: 0.5rem;
		background: #fff;
	}
	.visitor-list .no-content{border-top: 1px solid #f3f3f3;}
	.visitor-list li{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 0.5rem 1rem;
		background: #fff;
		border-top: 1px solid #f3f3f3;
	}
	.visitor-list li .item-option{
		padding: 0.3rem;
	}
	.visitor-list li .item-option:active{
		background: #fafafa;
	}
	.visitor-list li .item-option img{
		width: 1.5rem;
	}
	.visitor-list li .item-img{
		border-radius: 50%;
		overflow: hidden;
		width: 3.2rem;
		height: 3.2rem;
		display: flex;
		justify-content: center;
		align-items: center;
		background: #f3f3f3;
	}
	.visitor-list li .item-img img{
		width: 3.2rem;
	}
	.visitor-list li .item-text{
		padding: 0 0.5rem;
		flex: 1;
	}
	.visitor-list li .item-text img{
		width: 1.5rem;
		margin: 0 0.2rem;
	}
	.visitor-list li .item-text p{
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.visitor-list li .item-name{
		font-size: 1rem;
		line-height: 1.5rem;
		color: #282828;
		font-weight: bold;
	}
	.visitor-list li .item-other{
		font-size: 0.8rem;
		color: #7b7b7b;
		line-height: 1.5rem;
	}
	
</style>


// WEBPACK FOOTER //
// src/components/Mine/MyVisitor.vue